var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form-detail',{attrs:{"controller":_vm.controller,"readonly":_vm.readonly,"source":_vm.source},on:{"close":function($event){return _vm.$emit('close')},"save":function($event){return _vm.$emit('save')}}},[_c('entity-card-e-mail-detail',{attrs:{"codes":_vm.contentMixin.codes,"readonly":_vm.readonly,"source":_vm.source}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }